import { render, staticRenderFns } from "./GigStatus.htm?vue&type=template&id=163605c2&scoped=true&"
import script from "./GigStatus.ts?vue&type=script&lang=js&"
export * from "./GigStatus.ts?vue&type=script&lang=js&"
import style0 from "./GigStatus.scss?vue&type=style&index=0&id=163605c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163605c2",
  null
  
)

export default component.exports